import React, { useState, useEffect } from "react";
import { Modal, Form, Select, Input, Upload, Button, Row, Col, DatePicker, Switch, message } from "antd";
import { UploadOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import ParticipantForm from "../Participantes/ParticipantForm"
import { getParticipantes } from '../../services/participant/participantesServices';
const { TextArea } = Input;
const { Option } = Select;

export default function NovedadFormAntd({ open, onOpenChange, novedadEditando, onGuardar, onActualizar, onCancelar, departamentos, municipios, participantes, userLogin,  onSuccess }) {
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({
    soportes: [],
    participanteCedula: "",
    soportesReemplazo: []  // Nuevo estado para soportes del reemplazo
  });
  const [municipiosFiltrados, setMunicipiosFiltrados] = useState([]);
  const [participantesFiltrados, setParticipantesFiltrados] = useState([]);
  const [uploadFileList, setUploadFileList] = useState([]);
  const [uploadFileListReemplazo, setUploadFileListReemplazo] = useState([]); // Nuevo estado para archivos de reemplazo
  const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState(null);
  const [municipioSeleccionado, setMunicipioSeleccionado] = useState(null);
  const [formInicializado, setFormInicializado] = useState(false);
  const [usuarioReemplazado, setUsuarioReemplazado] = useState(
    novedadEditando ? !!novedadEditando.participante_reemplazo_oid : false
  );


    const [modalOpen, setModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState("create");
    const [selectedParticipant, setSelectedParticipant] = useState(null);



  useEffect(() => {
    if (departamentoSeleccionado) {
      const filtrados = municipios.filter(
        (m) => m.oid_depto === parseInt(departamentoSeleccionado)
      );
      setMunicipiosFiltrados(filtrados);
      form.setFieldsValue({
        municipioSeleccionado: undefined,
        participanteSeleccionado: undefined,
        participanteReemplazo: undefined,
      });
      setParticipantesFiltrados([]);
    }
  }, [departamentoSeleccionado]);

  useEffect(() => {
    if (municipioSeleccionado) {
      const filtrados = participantes.filter(
        (p) => p.oid_municipio === parseInt(municipioSeleccionado)
      );
      setParticipantesFiltrados(filtrados);

      if (!novedadEditando) {
        form.setFieldsValue({
          participanteSeleccionado: undefined,
          participanteReemplazo: undefined,
        });
      }
    }
  }, [municipioSeleccionado]);

  useEffect(() => {
    if (!open) return;
    if (novedadEditando) {
      const departamentoId = novedadEditando.oid_departamento?.toString();
      const municipioId = novedadEditando.oid_municipio?.toString();
      setMunicipioSeleccionado(municipioId);
      const nuevosMunicipios = municipios.filter(
        (m) => m.oid_depto.toString() === departamentoId
      );
      setMunicipiosFiltrados(nuevosMunicipios);
      const nuevosParticipantes = participantes.filter(
        (p) => p.oid_municipio.toString() === municipioId
      );
      setParticipantesFiltrados(nuevosParticipantes);
      const soportesCargados = (novedadEditando.soportes || []).map((sop, i) => ({
        id: sop.id || `exist-${i}`,
        uid: sop.id || `exist-${i}`,
        nombre: sop.nombre_real || sop.nombre,
        name: sop.nombre_real || sop.nombre,
        status: "done",
        url: sop.path || sop.url,
        ...sop,
      }));

      // Cargar soportes de reemplazo si existen
      const soportesReemplazoCargados = (novedadEditando.soportesRemplazo || []).map((sop, i) => ({
        id: sop.id || `exist-reemplazo-${i}`,
        uid: sop.id || `exist-reemplazo-${i}`,
        nombre: sop.nombre_real || sop.nombre,
        name: sop.nombre_real || sop.nombre,
        status: "done",
        url: sop.path || sop.url,
        ...sop,
      }));

     

      const tieneReemplazo = !!novedadEditando.participante_remplazo || !!novedadEditando.participanteReemplazo;
      setUsuarioReemplazado(tieneReemplazo);

      setFormData((prev) => ({
        ...prev,
        soportes: soportesCargados,
        soportesReemplazo: soportesReemplazoCargados,
        participanteCedula:
          nuevosParticipantes.find((p) => p.oid === novedadEditando.participante_oid)
            ?.numero_identificacion || "",
      }));

      setUploadFileList(soportesCargados);
      setUploadFileListReemplazo(soportesReemplazoCargados);

    } else if (!formInicializado) {
    // Solo limpiar una vez al entrar en modo "crear"
    form.resetFields();
    limpiarFormulario();
    setUsuarioReemplazado(false);
    setFormInicializado(true);
  }
  }, [novedadEditando, municipios, participantes, open]);

  useEffect(() => {
    if (
      novedadEditando &&
      municipiosFiltrados.length > 0 &&
      participantesFiltrados.length >= 0 &&
      !formInicializado
    ) {
      const municipioEncontrado = municipios.find(m => m.oid === novedadEditando.oid_municipio);
      const participanteEncontrado = participantes.find(p => p.oid === novedadEditando.participante_oid);
      const participanteReemplazoEncontrado = participantes.find(
        p => p.oid.toString() === novedadEditando.participante_remplazo?.toString()
      );
      // Asegurar que el participante reemplazo esté en los filtrados
      if (participanteReemplazoEncontrado && !participantesFiltrados.some(p => p.oid === participanteReemplazoEncontrado.oid)) {
        setParticipantesFiltrados(prev => [...prev, participanteReemplazoEncontrado]);
      }
      const valuesToSet = {
        departamentoSeleccionado: novedadEditando.oid_departamento?.toString(),
        municipioSeleccionado: municipioEncontrado
          ? { value: municipioEncontrado.oid.toString(), label: municipioEncontrado.municipio }
          : undefined,
        participanteSeleccionado: participanteEncontrado
          ? { value: participanteEncontrado.oid.toString(), label: `${participanteEncontrado.numero_identificacion} - ${participanteEncontrado.nombre_participante}` }
          : undefined,
        participanteReemplazo: participanteReemplazoEncontrado
          ? {
            value: participanteReemplazoEncontrado.oid.toString(),
            label: `${participanteReemplazoEncontrado.numero_identificacion} - ${participanteReemplazoEncontrado.nombre_participante}`
          }
          : undefined,
        tipoNovedad: novedadEditando.tipo_novedad?.toString(),
        observacion: novedadEditando.observacion || "",
        fecha_registro: novedadEditando.fecha_registro ? dayjs(novedadEditando.fecha_registro) : null,
        estado_reemplazo: novedadEditando.estado_remplazo === 1,
        estado: novedadEditando.estado?.toString(),
      };

      form.setFieldsValue(valuesToSet);
      setFormInicializado(true);
    }
  }, [municipiosFiltrados.length, participantesFiltrados.length, formInicializado]);

  const limpiarFormularioCreatPart = async () => {
  try {
    const data = await getParticipantes();
    if (municipioSeleccionado) {
      const filtrados = data.data.filter(
        (p) => p.oid_municipio === parseInt(municipioSeleccionado)
      );
      setParticipantesFiltrados(filtrados); // actualiza la lista del select
    }
  } catch (error) {
    message.error("Error al cargar los participantes");
  }
};


const limpiarFormulario = () => {
  form.resetFields();
  setMunicipiosFiltrados([]);
  setParticipantesFiltrados([]);
  setUploadFileList([]);
  setUploadFileListReemplazo([]);
  setFormData({ soportes: [], soportesReemplazo: [], participanteCedula: "" });
  setDepartamentoSeleccionado(null);
  setMunicipioSeleccionado(null);
  setFormInicializado(false);
  setUsuarioReemplazado(false);
};



const handleGuardar = async () => {
  try {
    const values = await form.validateFields();
    // Validar manualmente el campo participanteReemplazo
    if (usuarioReemplazado) {
      const participanteReemplazoValue = form.getFieldValue('participanteReemplazo');
      
      // Manejar tanto objeto {value, label} como string
      let participanteReemplazoValido = false;
      
      if (participanteReemplazoValue) {
        if (typeof participanteReemplazoValue === 'object') {
          participanteReemplazoValido = !!participanteReemplazoValue.value;
        } else {
          participanteReemplazoValido = !!participanteReemplazoValue;
        }
      }
      
      if (!participanteReemplazoValido) {
        message.error("Debe seleccionar un participante que reemplaza");
        return;
      }
    }


      // Validar que si el estado es inactivo y se seleccionó reemplazo, 
      // debe haber al menos un soporte de reemplazo
      if (values.estado === "2" && usuarioReemplazado && formData.soportesReemplazo.length === 0) {
        message.error("Debe agregar al menos un soporte para el reemplazo");
        return;
      }

      const tieneReemplazo = values.estado === "2" && usuarioReemplazado;

      const success = onGuardar({
        ...values,
        participanteSeleccionado: typeof values.participanteSeleccionado === 'object'
          ? values.participanteSeleccionado.value
          : values.participanteSeleccionado,
        participanteReemplazo: tieneReemplazo && typeof values.participanteReemplazo === 'object'
          ? values.participanteReemplazo.value
          : tieneReemplazo ? values.participanteReemplazo : null,
        estado_remplazo: tieneReemplazo ? 1 : 0,
        fecha_registro: values.fecha_registro ? values.fecha_registro.format("YYYY-MM-DD") : "",
        estado: values.estado,
        soportes: formData.soportes.map(sop => ({ ...sop, tipo: 1 })),
        soportesReemplazo: formData.soportesReemplazo.map(sop => ({ ...sop, tipo: 2 })),
        participanteCedula: formData.participanteCedula,
      });

      if (success) {
        limpiarFormulario();
        onOpenChange(false);
      }
    } catch (err) {
      console.warn("Formulario inválido", err);

      // Mostrar mensaje de error específico para participanteReemplazo
      if (err.errorFields && err.errorFields.some(field => field.name.includes('participanteReemplazo'))) {
        message.error("Debe seleccionar un participante que reemplaza");
      }
    }
  };

  const handleActualizar = async () => {
    try {
      const values = await form.validateFields();
      const tieneReemplazo = values.estado === "2" && usuarioReemplazado;
      const estadoRemplazoValue = tieneReemplazo ? 1 : 0;

      // Validar que si el estado es inactivo y se seleccionó reemplazo, 
      // debe haber al menos un soporte de reemplazo
      if (values.estado === "2" && usuarioReemplazado && formData.soportesReemplazo.length === 0) {
        message.error("Debe agregar al menos un soporte para el reemplazo");
        return;
      }

      // Extraer valores correctamente de los objetos labelInValue
      const participanteSeleccionadoValue = typeof values.participanteSeleccionado === 'object'
        ? values.participanteSeleccionado.value
        : values.participanteSeleccionado;

      const participanteReemplazoValue = values.participanteReemplazo && typeof values.participanteReemplazo === 'object'
        ? values.participanteReemplazo.value
        : values.participanteReemplazo;

      const formDataEnvio = new FormData();
      formDataEnvio.append("participante_oid", participanteSeleccionadoValue);
      formDataEnvio.append("tipo_novedad", values.tipoNovedad);
      formDataEnvio.append("observacion", values.observacion);
      formDataEnvio.append("fecha_registro", values.fecha_registro.format("YYYY-MM-DD"));
      formDataEnvio.append("cedula", formData.participanteCedula);
      formDataEnvio.append("participante_remplazo", participanteReemplazoValue ?? '');
      formDataEnvio.append("estado_remplazo", estadoRemplazoValue.toString());
      formDataEnvio.append("estado", values.estado);
      formDataEnvio.append("usuario", userLogin);

      // Agregar participante de reemplazo si existe y el estado es inactivo
      if (values.estado === "2" && usuarioReemplazado && values.participanteReemplazo) {
        formDataEnvio.append("participante_reemplazo_oid", participanteReemplazoValue);
      }

      // Agregar soportes principales
      formData.soportes.forEach((sop, index) => {
        if (sop.archivo) {
          formDataEnvio.append("soportes", sop.archivo);
          formDataEnvio.append(`estado_${index}`, sop.estado ?? '1');
          formDataEnvio.append(`tipo_soporte_${index}`, sop.tipo_soporte ?? '');
          formDataEnvio.append(`soporte_tipo`, '1');
        }
      });

      // Agregar soportes de reemplazo
      const startIndex = formData.soportes.length;
      formData.soportesReemplazo.forEach((sop, index) => {
        if (sop.archivo) {
          const globalIndex = startIndex + index;
          formDataEnvio.append("soportes", sop.archivo);
          formDataEnvio.append(`estado_${globalIndex}`, sop.estado ?? '1');
          formDataEnvio.append(`tipo_soporte_${globalIndex}`, sop.tipo_soporte ?? '');
          formDataEnvio.append(`soporte_tipo`, '2');
        }
      });
      // IDs de soportes principales a eliminar
      const idsAEliminar = novedadEditando?.soportes
        ?.filter((s) => !formData.soportes.some((f) => f.id === s.id))
        .map((s) => s.id) || [];

      // IDs de soportes de reemplazo a eliminar  
      const idsAEliminarReemplazo = novedadEditando?.soportesRemplazo
        ?.filter((s) => !formData.soportesReemplazo.some((f) => f.id === s.id))
        .map((s) => s.id) || [];

      // Combinar ambos arrays de IDs a eliminar
      const todosLosIdsAEliminar = [...idsAEliminar, ...idsAEliminarReemplazo];
      formDataEnvio.append("eliminar_soportes", JSON.stringify(todosLosIdsAEliminar));


      const success = await onActualizar(formDataEnvio, novedadEditando.oid);
      if (success) {
        limpiarFormulario();
        onOpenChange(false);
      }
    } catch (err) {
      console.warn("Formulario inválido", err);
    }
  };

  const handleFileChange = ({ fileList }, tipo) => {
    const nuevos = fileList
      .filter((f) => f.originFileObj)
      .map((file, index) => ({
        id: Date.now().toString() + index,
        nombre: file.name,
        archivo: file.originFileObj,
        url: URL.createObjectURL(file.originFileObj),
        estado: "1",
        tipo_soporte: file.name.split(".").pop().toUpperCase() ?? "PDF",
      }));

    if (tipo === 'principal') {
      const existentes = formData.soportes.filter((s) => !s.archivo);
      const nuevosSoportes = [...existentes, ...nuevos];
      setFormData((prev) => ({
        ...prev,
        soportes: nuevosSoportes,
      }));
      setUploadFileList(fileList);
    } else if (tipo === 'reemplazo') {
      const existentes = formData.soportesReemplazo.filter((s) => !s.archivo);
      const nuevosSoportes = [...existentes, ...nuevos];
      setFormData((prev) => ({
        ...prev,
        soportesReemplazo: nuevosSoportes,
      }));
      setUploadFileListReemplazo(fileList);
    }
  };

  const eliminarSoporte = (id, tipo) => {
    if (tipo === 'principal') {
      const nuevos = formData.soportes.filter((s) => s.id !== id);
      setFormData((prev) => ({ ...prev, soportes: nuevos }));
      setUploadFileList((prev) => prev.filter((f) => f.id !== id));
    } else if (tipo === 'reemplazo') {
      const nuevos = formData.soportesReemplazo.filter((s) => s.id !== id);
      setFormData((prev) => ({ ...prev, soportesReemplazo: nuevos }));
      setUploadFileListReemplazo((prev) => prev.filter((f) => f.id !== id));
    }
  };

  const handleCrearParticipante = () => {
    setModalMode("create");
    setModalOpen(true);
  };

  return (<>
    <Modal
      title={novedadEditando ? "Editar Novedad" : "Registrar Nueva Novedad"}
      open={open}
      forceRender 
      onCancel={() => {
        limpiarFormulario();
        onCancelar();
        onOpenChange(false);
      }}
      width={700}
      onOk={novedadEditando ? handleActualizar : handleGuardar}
      okText={novedadEditando ? "Actualizar" : "Guardar"}
      cancelText="Cancelar"
    >
      <Form
        form={form}
        layout="vertical"
        onValuesChange={(changedValues, allValues) => {
          if (changedValues.departamentoSeleccionado) {
            setDepartamentoSeleccionado(changedValues.departamentoSeleccionado);
          }
          if (changedValues.municipioSeleccionado) {
            setMunicipioSeleccionado(changedValues.municipioSeleccionado?.value || changedValues.municipioSeleccionado);
          }
          if (changedValues.estado && changedValues.estado !== "2") {
            setUsuarioReemplazado(false);
          }
          setFormData((prev) => ({ ...prev, ...allValues }));
        }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Departamento *"
              name="departamentoSeleccionado"
              rules={[{ required: true, message: "Seleccione un departamento" }]}
            >
              <Select placeholder="Seleccione un departamento">
                {departamentos.map((dep) => (
                  <Option key={dep.oid} value={dep.oid.toString()}>
                    {dep.departamento}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Municipio *"
              name="municipioSeleccionado"
              rules={[{ required: true, message: "Seleccione un municipio" }]}
            >
              <Select
                placeholder="Seleccione un municipio"
                labelInValue
                onChange={(option) => {
                  setMunicipioSeleccionado(option.value);
                }}
              >
                {municipiosFiltrados.map((mun) => (
                  <Option key={mun.oid} value={mun.oid.toString()}>
                    {mun.municipio}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Participante *"
              name="participanteSeleccionado"
              rules={[{ required: true, message: "Seleccione un participante" }]}
            >
              <Select
  showSearch
  labelInValue
  placeholder="Seleccione un participante"
  optionFilterProp="children"
  filterOption={(input, option) =>
    option?.children
      ?.toString()
      .toLowerCase()
      .includes(input.toLowerCase())
  }
  onChange={(option) => {
    setFormData((prev) => ({
      ...prev,
      participanteCedula:
        participantesFiltrados.find(
          (p) => p.oid.toString() === option.value
        )?.numero_identificacion || "",
    }));
  }}
>
  {participantesFiltrados.map((part) => (
    <Option key={part.oid} value={part.oid.toString()}>
      {part.numero_identificacion} - {part.nombre_participante}
    </Option>
  ))}
</Select>

            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Tipo de Criterios *"
              name="tipoNovedad"
              rules={[
                { required: true, message: "Seleccione el tipo de novedad" },
              ]}
            >
              <Select placeholder="Seleccione el tipo de novedad">
                <Option value="1">Fallecimiento</Option>
                <Option value="2">Retiro Voluntario</Option>
                <Option value="3">Exclusión</Option>
                <Option value="4">Corrección o actualización de información</Option>
                <Option value="5">Otra</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Fecha de Registro *"
              name="fecha_registro"
              rules={[{ required: true, message: "Seleccione la fecha de registro" }]}
            >
              <DatePicker
                format="DD-MM-YYYY"
                style={{ width: "100%" }}
                placeholder="Seleccione fecha de registro"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Estado *"
              name="estado"
              rules={[{ required: true, message: "Seleccione el estado" }]}
            >
              <Select
                placeholder="Seleccione el estado"
                onChange={(value) => {
                  if (value !== "2") {
                    setUsuarioReemplazado(false);
                  }
                }}
              >
                <Option value="1">Activo</Option>
                <Option value="2">Inactivo</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {form.getFieldValue('estado') === '2' && (
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="estado_reemplazo" label="¿El participante fue reemplazado?" valuePropName="checked">
                <Switch
                  onChange={(checked) => {
                    setUsuarioReemplazado(checked);
                    if (!checked) {
                      form.setFieldsValue({ participanteReemplazo: undefined });
                    }
                  }}
                  checkedChildren="Sí"
                  unCheckedChildren="No"
                />
              </Form.Item>




            </Col>
          </Row>
        )}

        {form.getFieldValue('estado') === '2' && usuarioReemplazado && (
          <>
         <Row gutter={16} align="middle">
  <Col span={20}>
    <Form.Item
      label="Participante que reemplaza *"
      name="participanteReemplazo"
      rules={[{ required: usuarioReemplazado, message: "Seleccione el participante que reemplaza" }]}
    >
      <Select
        showSearch
        labelInValue
        placeholder="Seleccione el participante que reemplaza"
        optionFilterProp="label"
        filterOption={(input, option) =>
          option?.label?.toLowerCase().includes(input.toLowerCase())
        }
        options={participantesFiltrados.map((part) => ({
          value: part.oid.toString(),
          label: `${part.numero_identificacion} - ${part.nombre_participante}`,
        }))}
      />
    </Form.Item>
  </Col>
  <Col span={4}>
    <Button type="primary" icon={<PlusOutlined />} onClick={handleCrearParticipante} style={{ marginTop: 30 }}>
      Crear
    </Button>
  </Col>
</Row>


          </>
        )}

        <Form.Item
          label=" Descripción de la novedad *"
          name="observacion"
          rules={[{ required: true, message: "Ingrese una observación" }]}
        >
          <TextArea
            rows={4}
            placeholder="Describa la novedad..."
          />
        </Form.Item>

        <Form.Item label="Soportes de la novedad">
          <Upload
            multiple
            showUploadList={false}
            beforeUpload={() => false}
            fileList={uploadFileList}
            onChange={({ fileList }) => {
              setUploadFileList(fileList);
              handleFileChange({ fileList }, 'principal');
            }}
          >
            <Button icon={<UploadOutlined />}>Seleccionar Archivos</Button>
          </Upload>
          <div style={{ marginTop: 10 }}>
            {formData.soportes.map((soporte) => (
              <div
                key={soporte.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 8,
                  padding: 8,
                  border: "1px solid #d9d9d9",
                  borderRadius: 4,
                }}
              >
                <span>{soporte.nombre}</span>
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={() => eliminarSoporte(soporte.id, 'principal')}
                />
              </div>
            ))}
          </div>
        </Form.Item>
        {form.getFieldValue('estado') === '2' && usuarioReemplazado && (
          <>
            <Form.Item
              label="Soportes del reemplazo *"
              required
              help="Documentos que respaldan el reemplazo del participante"
            >
              <Upload
                multiple
                showUploadList={false}
                beforeUpload={() => false}
                fileList={uploadFileListReemplazo}
                onChange={({ fileList }) => {
                  setUploadFileListReemplazo(fileList);
                  handleFileChange({ fileList }, 'reemplazo');
                }}
              >
                <Button icon={<UploadOutlined />}>Seleccionar Archivos</Button>
              </Upload>
              <div style={{ marginTop: 10 }}>
                {formData.soportesReemplazo.map((soporte) => (
                  <div
                    key={soporte.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: 8,
                      padding: 8,
                      border: "1px solid #d9d9d9",
                      borderRadius: 4,
                    }}
                  >
                    <span>{soporte.nombre}</span>
                    <Button
                      type="text"
                      icon={<DeleteOutlined />}
                      onClick={() => eliminarSoporte(soporte.id, 'reemplazo')}
                    />
                  </div>
                ))}
              </div>
            </Form.Item>
          </>)}
      </Form>
    </Modal>
   <ParticipantForm
                  isOpen={modalOpen}
                  onClose={() => setModalOpen(false)}
                  participant={selectedParticipant}
                  onSuccess={onSuccess}
                  mode={modalMode}
                  limpiar={limpiarFormularioCreatPart}
                /></>

  );
}
